import React from 'react'

import { mainColors, useIsTabletOrMobile } from '@avantstay/backoffice-core'
import { IconSearch } from '@avantstay/backoffice-vectors'

import * as S from '../OmniSearch.styles'

interface ITextWithSearchIconProps {
  text: string
}

const TextWithSearchIcon = ({ text }: ITextWithSearchIconProps) => {
  return (
    <S.InstructionsContainer>
      <IconSearch color={mainColors.neutralDark} width={14} />
      <em>{text}</em>
    </S.InstructionsContainer>
  )
}

const Instructions = (): JSX.Element => {
  const isTabletOrMobile = useIsTabletOrMobile()
  const bookingText = `b: endless summer${isTabletOrMobile ? '' : ' Nov 13-14'}`

  return (
    <S.InstructionsMessage data-cy="omni-search-instruction-message">
      <S.InstructionItem>
        To search <strong>only properties:</strong>
        <TextWithSearchIcon text="p: oceana" />
      </S.InstructionItem>
      <S.InstructionItem>
        To search <strong>only bookings:</strong>
        <TextWithSearchIcon text={bookingText} />
      </S.InstructionItem>
      <S.InstructionItem>
        To search <strong>only guests:</strong>
        <TextWithSearchIcon text="u: John Doe" />
      </S.InstructionItem>
      <S.InstructionItem>
        To search <strong>only homeowners:</strong>
        <TextWithSearchIcon text="h: John Doe" />
      </S.InstructionItem>
    </S.InstructionsMessage>
  )
}

export default Instructions
